import { MoreHorizontal } from "lucide-react"

import { cn } from "@/lib/utils"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export interface ContextMenuItem {
  id: string
  label: string
  destructive?: boolean
}

export interface ContextMenuButtonProps {
  items: ContextMenuItem[]
  "aria-label"?: string
  className?: string
  onSelect?: (id: string) => void
}

export function ContextMenuButton({
  items,
  className,
  "aria-label": ariaLabel = "Open actions menu",
  onSelect,
}: ContextMenuButtonProps) {
  if (items.length === 0) {
    return null
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex h-7 w-7 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-700",
            className,
          )}
          aria-label={ariaLabel}
        >
          <MoreHorizontal className="h-4 w-4" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-40 p-1.5 text-xs"
      >
        <ul className="space-y-0.5">
          {items.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={cn(
                  "flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-slate-700 hover:bg-slate-50",
                  item.destructive &&
                    "text-red-600 hover:bg-red-50 hover:text-red-700",
                )}
                onClick={() => onSelect?.(item.id)}
              >
                <span>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  )
}
